module.exports = __webpack_public_path__ + "static/media/ios-notifications.c39ec1cc.svg";